import React, { useEffect, useState } from 'react';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import styles from './index.module.scss';
type MenuItem = Required<MenuProps>['items'][number];

// const items: MenuItem[] = [
//   { label: '菜单项一', key: 'item-1' }, // 菜单项务必填写 key
//   { label: '菜单项二', key: 'item-2' },
//   {
//     label: '子菜单',
//     key: 'submenu',
//     children: [{ label: '子菜单项', key: 'submenu-item-1' }],
//   },
// ];

interface IMenuAnchor {
  items: MenuItem[];
  rootSubmenuKeys?: string[];
  openKeys?: string[];
  selectedKeys?: string[];
  style?: any;
  onSelect?: (k: string) => void;
}

export default function MenuAnchor({ items, selectedKeys, style, onSelect }: IMenuAnchor) {
  const [selectedKeysVal, setSelectedKeysVal] = useState(selectedKeys);
  // const [openKeysVal, setOpenKeysVal] = useState(openKeys);
  // const rootSubmenuKeys = items?.map(item => item?.key);
  // useEffect(() => {
  //   setOpenKeysVal(openKeys);
  // }, [openKeys]);
  useEffect(() => {
    setSelectedKeysVal(selectedKeys);
  }, [selectedKeys]);
  // const onOpenChange: MenuProps['onOpenChange'] = keys => {
  // setOpenKeysVal(keys);
  // };
  const onSelectChange = ({ key }) => {
    setSelectedKeysVal(key);
    onSelect(key);
  };
  return (
    <div className={styles.menuAnchor}>
      <Menu
        mode="inline"
        selectedKeys={selectedKeysVal}
        // openKeys={openKeysVal}
        // onOpenChange={onOpenChange}
        onSelect={onSelectChange}
        style={style}
        items={items}
      />
    </div>
  );
}
